export default {
  moeda(param, currency = 'BRL') {
    let number = param;
    if (typeof number === 'string') {
      number = parseFloat(number);
    }

    if (Number.isNaN(Number(number))) return null;

    if (number === 0.0) return 'Grátis';

    if (currency === null || currency === undefined) {
      return number.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }

    return number.toLocaleString('pt-BR', { style: 'currency', currency });
  },

  dataFormatada(date, year = 'numeric', month = 'long', day = 'numeric') {
    const novaData = date || '';

    const data = new Date(novaData.replace(' ', 'T'));
    const options = { month, day };

    if (year) {
      options.year = year;
    }

    return data.toLocaleString('pt-BR', options);
  },

  horaFormatada(date, hour = 'numeric', minute = 'numeric', second) {
    const novaData = date || '';

    const data = new Date(novaData.replace(' ', 'T'));

    return data.toLocaleString('pt-BR', { hour, minute, second });
  },

  getTextItemOrderBump(qtdeItems) {
    const formatted = parseInt(qtdeItems, 10) > 1 ? ' itens' : ' item';
    return `+ ${qtdeItems} ${formatted}`;
  },

  textoMaiusculo(value) {
    if (!value) return '';
    const novoValue = value.toString();
    return novoValue.toUpperCase();
  },

  linkTelefone(value) {
    const telefone = value.match(/\d+/g).join([]);

    return `tel:${telefone}`;
  },

  linkWhatsappDesktop(value) {
    const telefone = value.match(/\d+/g).join([]);

    return `https://web.whatsapp.com/send?l=pt_BR&phone=55${telefone}`;
  },
};
